@if (!lotMappedItem.hasUnits) {
    <mat-tab-group mat-stretch-tabs="false">
        <mat-tab label="Exterior">
            <div
                class="flex-row flex"
                [ngClass]="{ 'cb-image-button': isValidExteriorImage }"
                (click)="
                    viewImage(
                        isValidExteriorImage,
                        lotMappedItem.exteriorImageUrl,
                        'Exterior Image'
                    )
                "
            >
                <img
                    #exteriorImage
                    mat-card-image
                    [src]="lotMappedItem.exteriorImageUrl"
                    cbHandleInvalidImage
                    (error)="handleInvalidExteriorImage()"
                    alt="Exterior Image"
                />
                @if (isValidExteriorImage) {
                    <div class="bottom-right end-center flex-row">
                        <mat-icon class="cb-image-button-icon">zoom_in</mat-icon>
                    </div>
                }
            </div>
        </mat-tab>
        <mat-tab label="Floor Plan">
            <div
                class="flex-row flex"
                [ngClass]="{ 'cb-image-button': isValidFloorPlanImage }"
                (click)="
                    viewImage(
                        isValidFloorPlanImage,
                        lotMappedItem.floorPlanImageUrl,
                        'Floor Plan Image'
                    )
                "
            >
                <img
                    #floorPlanImage
                    mat-card-image
                    [src]="lotMappedItem.floorPlanImageUrl"
                    cbHandleInvalidImage
                    (error)="handleInvalidFloorPlanImage()"
                    alt="Floor Plan Image"
                />
                @if (isValidFloorPlanImage) {
                    <div class="bottom-right end-center flex-row">
                        <mat-icon class="cb-image-button-icon">zoom_in</mat-icon>
                    </div>
                }
            </div>
        </mat-tab>
    </mat-tab-group>
}
